import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDimensions } from "../hooks";
import ContactSupport from "../components/ContactSupport";
import config from "../config/config";
import { getSupportChannelConfig } from "../utils/getSupportChannelConfig";

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const { isSmall } = useDimensions();
  const height = isSmall ? "200px" : "200px";

  const handleTryAgain = () => {
    navigate("/bankatlantic");
    navigate(0);
  };

  return (
    <Box
      sx={{
        backgroundImage: "url(./assets/errorBackground.png)",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Grid container alignItems="center" sx={{ width: "100%" }} spacing={6}>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ marginLeft: { md: "130px", lg: "150px" } }}
        >
          <Box sx={{ color: "white" }}>
            <img
              src={"/assets/maviance.png"}
              alt="Logo"
              style={{ height, width: "auto", marginRight: 0, paddingTop: 5 }}
            />
            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 500,
              }}
            >
              Oups!
            </Typography>
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontWeight: 700,
                fontSize: { xs: "2.5rem", md: "3.5rem" },
                lineHeight: 1.2,
              }}
            >
              The page you are looking for
              <Typography
                component="span"
                variant="h2"
                sx={{
                  display: "block",
                  color: "#fbbf24",
                  mt: 1,
                  fontWeight: 700,
                  fontSize: "inherit",
                }}
              >
                can’t be found{" "}
              </Typography>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: "1.1rem",
              }}
            >
              Don't worry though, we're here to help you get back on track!
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Button
                variant="contained"
                size="large"
                fullWidth
                //startIcon={<Home />}
                onClick={handleTryAgain}
                sx={{
                  backgroundColor: "#fbbf24",
                  color: "#1a1464",
                  fontWeight: 600,
                  py: 1.5,
                  "&:hover": {
                    backgroundColor: "#f59e0b",
                  },
                }}
              >
                Try Again
              </Button>
              {/* Replaces a "Contact support" button that carried no onClick
                  and no href -- it looked like support and did nothing. */}
              <ContactSupport
                signals={{ stage: "unknown" }}
                facts={{ route: "/" }}
                config={getSupportChannelConfig(config)}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ErrorPage;
